import React from 'react';
import MegaMenu from '../MegaMenu/MegaMenu';
import clsx from 'clsx';
import Icon from '../Icon';

const NavigationLink = ({
  link,
  isActive,
  onLinkHover,
  onMouseLeaveLink,
  onMegaMenuClose,
}) => (
  <>
    {link.url && (
      <a
        href={link.url}
        className={clsx('navbar__link', isActive && 'navbar__link--active')}
        onMouseOver={onLinkHover}
        onMouseLeave={onMouseLeaveLink}
        onFocus={onLinkHover}
      >
        {link.name}{' '}
        {!!link.links?.length && (
          <Icon
            name="Caret-Down"
            className={clsx(
              'navbar__link-icon',
              isActive && 'navbar__link-icon--active'
            )}
            size={16}
          />
        )}
      </a>
    )}

    {link.links?.length > 0 && (
      <MegaMenu
        onMegaMenuClose={onMegaMenuClose}
        onMouseLeaveMegaMenu={onMouseLeaveLink}
        onMouseOverMegaMenu={() => onLinkHover(link)}
        link={link}
        open={isActive}
      />
    )}
  </>
);

export default NavigationLink;
